// Màu chính của hệ thống
export const COLORS = {
  PRIMARY: '#17C89E',
  PRIMARY_2: '#2c2d2c',
  PRIMARY_RGB: '#17C89E',
  PRIMARY_RGB_2: 'rgba(255, 127, 41, 0.44)',
  PRIMARY_RGB_3: 'rgba(255, 127, 41, 0.1)',
  // Màu cơ bản
  WHITE: '#ffffff',
  BLACK: '#000000',
  RED: '#ff5c5c',

  BORDER: '#e0e0e0',
  // Màu xám
  GRAY: {
    LIGHT: '#bbbbbb',
    MEDIUM: '#888888',
    DARK: '#444444',
    BORDER: '#6f6c6c',
    SPLIT: '#424242',
    BACKGROUND: '#303030',
    SHADOW: '#dddddd',
    TABLE_BORDER: '#eee',
  },
  // Màu nền
  BACKGROUND: {
    LIGHT: '#fff',
    DARK: '#000',
    DARK_2: '#1f1f1f',
    COMPONENT: '#303030',
    BODY: '#303030',
    POPOVER: '#303030',
  },
  // Màu trạng thái
  STATUS: {
    SUCCESS: '#008a00',
    ERROR: '#e60000',
    WARNING: '#ff9900',
    INFO: '#0066cc',
  },
  // Màu cho editor (ReactQuill)
  EDITOR_COLORS: [
    '#000000', // 0
    '#e60000', // 1
    '#ff9900', // 2
    '#ffff00', // 3
    '#008a00', // 4
    '#0066cc', // 5
    '#9933ff', // 6
    '#ffffff', // 7
    '#facccc', // 8
    '#ffebcc', // 9
    '#ffffcc', // 10
    '#cce8cc', // 11
    '#cce0f5', // 12
    '#ebd6ff', // 13
    '#bbbbbb', // 14
    '#f06666', // 15
    '#ffc266', // 16
    '#ffff66', // 17
    '#66b966', // 18
    '#66a3e0', // 19
    '#c285ff', // 20
    '#888888', // 21
    '#a10000', // 22
    '#b26b00', // 23
    '#b2b200', // 24
    '#006100', // 25
    '#0047b2', // 26
    '#6b24b2', // 27
    '#444444', // 28
    '#5c0000', // 29
    '#663d00', // 30
    '#666600', // 31
    '#003700', // 32
    '#002966', // 33
    '#3d1466', // 34
  ],

  // Màu CSS Variables
  CSS_VARS: {
    PRIMARY: 'var(--primary-color)',
    PRIMARY_BG: 'var(--primary-bg-color)',
  },
} as const;

// Thêm type cho TypeScript
export type ColorKey = keyof typeof COLORS;
export type GrayColorKey = keyof typeof COLORS.GRAY;
export type BackgroundColorKey = keyof typeof COLORS.BACKGROUND;
export type StatusColorKey = keyof typeof COLORS.STATUS;
